module.exports = __webpack_public_path__ + "static/media/Italian_Federico BG-28.576230ef.png";